<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>The Story Devotional: Discover Your Role In God’s Story: 365 Devotions</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="txaa1" id="p0005-02-1" style="margin-top: 10%;"><span>Give thanks to the Lord, for he is good;</span></p>
<p class="txaa"><span>his love endures forever.</span></p>
<p class="txaa1" id="p0005-02-2"><span>Let the redeemed of the Lord tell their story—</span></p>
<p class="txaa"><span>those he redeemed from the hand of the foe, </span></p>
<p class="txaa1"><span>those he gathered from the lands, </span></p>
<p class="txaa"><span>from east and west, from north and south.</span></p>
<p class="txab" id="p0005-02-3"><span><span class="small">PSALM</span> 107: 1–3 </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?a136ecde